import styled from '@emotion/styled';
import { InfoIcon as InfoIconDefault } from 'static/icons';

export const InfoIcon = styled(InfoIconDefault)<{ warning?: number, small?: number}>`
    path:first-of-type {
      fill: ${({ theme, warning }) => warning && theme.colors.pumpkin[2]};
    }
    path:not(first-of-type) {
      fill: ${({ theme, warning }) => warning && theme.colors.white};
    }
    width: ${({ theme, small }) => small && theme.textStyles.body1.fontSize};
    height:${({ theme, small }) => small && theme.textStyles.body1.fontSize};
`;
